import { render, staticRenderFns } from "./MatchVideo.vue?vue&type=template&id=8a75ecea&scoped=true&"
import script from "./MatchVideo.vue?vue&type=script&lang=js&"
export * from "./MatchVideo.vue?vue&type=script&lang=js&"
import style0 from "./MatchVideo.vue?vue&type=style&index=0&id=8a75ecea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a75ecea",
  null
  
)

export default component.exports